export default [
  {
    type: 'page',
    formItems: [
      {
        label: "页面背景图片",
        name: "backgroundImg",
        stamp: 'singleImage',
        key: "style",
        help:"推荐尺寸750*484，大小1M以内"
      },
      {
        label: "页面背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        help:"页面整体背景色"
      },
    ]
  },
  {
    type: 'windows',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "布局",
        name: "class",
        type: "text",
        stamp: 'radio',
        key: "style",
        help: '图片比例建议一致',
        options: [
          { label: '独占一行', value: 'full' },
          { label: '堆积两列', value: 'half' },
          { label: '堆积三列', value: 'third' },
          { label: '堆积四列', value: 'quarter' },
        ],
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      }
    ]
  },
  {
    type: 'notice',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "图标颜色",
        name: "iconColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "文字颜色",
        name: "textColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "文字内容",
        name: "content",
        key: "params",
        type: "text",
        stamp: 'input'
      },
    ]
  },
  {
    type: 'guessLove',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style",
      },
      {
        label: "栏目标题",
        name: "goodTitle",
        key: "params",
        type: "text",
        stamp: 'input'
      },
      {
        label: "展示标题",
        name: "show",
        stamp: 'switch',
        open:'显示',
        close:'隐藏',
        key: "params"
      },
      {
        label: "布局",
        name: "class",
        type: "text",
        stamp: 'radio',
        key: "style",
        help: '图片比例建议一致',
        options: [
          { label: '独占一行', value: 'full' },
          { label: '大图一行', value: 'whole' },
          { label: '堆积两列', value: 'half' },
        ],
      },
      {
        label: "推荐规则",
        name: "rules",
        stamp: 'select',
        key: "params",
        options: [
          { label: '自动推荐兑换量前10的礼品', value: 1 },
          { label: '自动推荐新上架前10个礼品', value: 2 },
          { label: '手动推荐', value: 3 },
        ],
      },
      {
        label: "推荐商品",
        key: "data",
        stamp: 'selectgood',
      }
    ]
  },
  {
    type: 'goods',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style",
        help:"商品为自动获取模式"
      },
      {
        label: "栏目标题",
        name: "goodTitle",
        key: "params",
        type: "text",
        stamp: 'input'
      },
      {
        label: "展示标题",
        name: "show",
        stamp: 'switch',
        open:'显示',
        close:'隐藏',
        key: "params"
      }
    ]
  },
  {
    type: 'nav',
    formItems: [
      {
        label: "图片导航",
        type: "image",
        key: "data",
        stamp: 'nav',
      }
    ]
  },
  {
    type: 'banner',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style",
        help:'滑块可用左右方向键精确调整'
      },
      {
        label: "切换时间",
        name: "interval",
        type: "text",
        stamp: 'input',
        key: "params",
        help: '轮播图自动切换的间隔时间，单位：毫秒',
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image'
      }
    ]
  },
  {
    type: 'search',
    formItems: [
      {
        label: "提示文字",
        name: "placeholder",
        key: "params",
        type: "text",
        stamp: 'input'
      },
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style",
        help:'滑块可用左右方向键精确调整'
      },
      {
        label: "主题色",
        name: "themeColor",
        key: "style",
        type: "color",
        stamp: 'input'
      }
    ]
  },
]